enum Status {
    /**
     * Extrayendo datos
     */
    EXTRACT_DATA = "extrayendo-datos",
    /**
     * Error extrayendo datos
     */
    ERROR_EXTRACT_DATA = "error-extrayendo-datos",
    /**
     * Cotejar documentos 
     */
    VERIFICATION = "cotejo",
    /**
     * Validando datos del fiado
     */
    VALIDATING_GUARANTOR = "validando-fiado",
    /**
     * Fiado invalido
     */
    INVALID_GUARANTOR = "fiado-invalido",
    /**
     * Error en la validación del fiado
     */
    GUARANTOR_VALIDATION_ERROR = "error-validacion-fiado",
    /**
     * Creando solicitud
     */
    CREATING_REQUEST = "creando-solicitud",
    /**
     * Fiado duplicado
     */
    DUPLICATE_GUARANTOR = "fiado-duplicado",
    /**
     * Error en la creación de la solicitud
     */
    CREATING_REQUEST_ERROR = "error-creando-solicitud",
    /**
     * Revisión del contrato
     */
    CONTRACT_REVIEW = "revision-contrato",
    /**
     * Revision del contrato por parte del fiado
     */
    GUARANTOR_CONTRACT_REVIEW = "revision-contrato-fiado",
    /**
     * En proceso de firma
     */
    IN_SIGNING = "en-firma",
    /**
     * Solicitud de actualización de datos por parte del agente
     */
    UPDATING_REQUEST = "actualizando-solicitud",
    /**
     * Error en la actualización de la solicitud
     */
    UPDATING_REQUEST_ERROR = "error-actualizando-solicitud",
    /**
     * Alta completa
     */
    REGISTRATION_COMPLETE = "alta-completa",
    /**
     * Solicitud de actualización de datos por parte del fiado
     */
    GUARANTOR_CHANGE_REQUEST = "solicitud-cambio-fiado",
    /**
     * Error legado
     */
    ERROR_LEGACY = "error-legacy",
    /**
     * Solicitud de cambio de agente
     */
    AGENT_CHANGE_REQUEST = "solicitud-cambio-agente",
    /**
     * Error en la revisión del contrato del fiado
     */
    ERROR_GUARANTOR_CONTRACT_REVIEW = "error-revision-contrato-fiado",
    /**
     * Error en la solicitud de cambio de agente*
     * */
    ERROR_AGENT_CHANGE_REQUEST = "error-solicitud-cambio-agente",
    /**
     * Error en la solicitud de cambio por fiado
     * */
    ERROR_GUARANTOR_CHANGE_REQUEST = "error-solicitud-cambio-fiado",
    /**
     * Error en firma
     */
    ERROR_IN_SIGNING = "error-en-firma",
    /**
     * Validación de operación en proceso
     */
    CONTRACT_VALIDATION = "validacion-operacion-en-proceso",
    /**
     * Error en la validación de la operación
     */
    CONTRACT_VALIDATION_REJECT = "corregir-firma",
    /**
     * Retomar solicitud por Siebel
     */
    CONTINUE_SIEBEL = "alta-retomada-siebel",
    /** 
     * En atención de operaciones
    */
    OPERATIONS_CHECKING = "en-atencion-operaciones",
    /** 
     * Pendiente de revisar por operaciones
    */
    OPERATIONS_PENDING_CHECK = "pendiente-de-revisar",
    /** 
     * Operación rechazada
    */
    OPERATION_REJECTED = "rechazada",
    /** 
     * Operación aprobada
    */
    OPERATION_APPROVED = "aprobada",
    /** 
     * Operación a corregir
    */
    CORRECT_INFO = "Corregir",
    /** 
     * Solicitud completa
    */
    REQUEST_COMPLETE = "solicitud-completa",
    /**
     * Error al corregir firma
     */
    ERROR_CORRECTING_SIGNATURE = "error-corregir-firma"
}
export default Status;

export interface Estado {

    message: string;
    isError: boolean;
}

export const estados: { [key: string]: Estado } = {
    [Status.EXTRACT_DATA]: { message: 'Extrayendo datos', isError: false },
    [Status.ERROR_EXTRACT_DATA]: { message: 'Error extrayendo datos', isError: true },
    [Status.VERIFICATION]: { message: 'En proceso', isError: false },
    [Status.VALIDATING_GUARANTOR]: { message: 'Validando fiado', isError: false },
    [Status.INVALID_GUARANTOR]: { message: 'Fiado no válido', isError: true },
    [Status.GUARANTOR_VALIDATION_ERROR]: { message: 'Error validando fiado', isError: true },
    [Status.CREATING_REQUEST]: { message: 'Creando solicitud', isError: false },
    [Status.DUPLICATE_GUARANTOR]: { message: 'Fiado duplicado', isError: true },
    [Status.CREATING_REQUEST_ERROR]: { message: 'Error creando solicitud', isError: true },
    [Status.CONTRACT_REVIEW]: { message: 'En revisión agente', isError: false },
    [Status.GUARANTOR_CONTRACT_REVIEW]: { message: 'En revisión fiado', isError: false },
    [Status.IN_SIGNING]: { message: 'En firma', isError: false },
    [Status.UPDATING_REQUEST]: { message: 'Actualizando solicitud', isError: false },

    [Status.UPDATING_REQUEST_ERROR]: { message: 'Error actualizando solicitud', isError: true },
    [Status.REGISTRATION_COMPLETE]: { message: 'Solicitud completa', isError: false },
    [Status.GUARANTOR_CHANGE_REQUEST]: { message: 'Corregir', isError: false },
    [Status.AGENT_CHANGE_REQUEST]: { message: 'En revisión agente', isError: false },
    [Status.ERROR_LEGACY]: { message: 'Error legacy', isError: true },
    [Status.ERROR_GUARANTOR_CONTRACT_REVIEW]: { message: 'Error revisión fiado', isError: true },
    [Status.ERROR_IN_SIGNING]: { message: 'Error firma', isError: true },
    [Status.ERROR_AGENT_CHANGE_REQUEST]: { message: 'Error revisión agente', isError: true },
    [Status.ERROR_GUARANTOR_CHANGE_REQUEST]: { message: 'Error revisión fiado', isError: true },
    [Status.CONTRACT_VALIDATION]: { message: 'En operaciones', isError: false },
    [Status.CONTRACT_VALIDATION_REJECT]: { message: 'Corregir', isError: true },
    [Status.CONTINUE_SIEBEL]: { message: 'Continuar en Punto Aserta', isError: false },

    [Status.OPERATIONS_CHECKING]: { message: 'En atención de operaciones', isError: false },
    [Status.OPERATIONS_PENDING_CHECK]: { message: 'Pendiente de revisar por operaciones', isError: false },
    [Status.OPERATION_REJECTED]: { message: 'Operación rechazada', isError: false },
    [Status.OPERATION_APPROVED]: { message: 'Operación aprobada', isError: false },
    [Status.CORRECT_INFO]: { message: 'Corregir', isError: false },
    [Status.REQUEST_COMPLETE]: { message: 'Solicitud completa', isError: false },
    [Status.ERROR_CORRECTING_SIGNATURE]: { message: 'Error al corregir firma', isError: true },
};

export const statusManualSigned: String[] = [
    Status.CONTRACT_REVIEW,
    Status.CONTRACT_VALIDATION_REJECT,
]

export const statusFAD = [
    Status.ERROR_IN_SIGNING,
    Status.IN_SIGNING,
    Status.ERROR_GUARANTOR_CONTRACT_REVIEW,
    Status.GUARANTOR_CONTRACT_REVIEW,
    Status.ERROR_GUARANTOR_CHANGE_REQUEST
]

export const satusReviewedOperation: String[] = [
    Status.CONTRACT_VALIDATION,
]

export const continueInPuntoAsertaStatus: Status[] = [
    Status.CONTRACT_VALIDATION_REJECT,
    Status.ERROR_GUARANTOR_CHANGE_REQUEST,
    Status.CONTRACT_REVIEW,
    Status.UPDATING_REQUEST_ERROR,
    Status.ERROR_IN_SIGNING,
    Status.ERROR_LEGACY,
    Status.ERROR_AGENT_CHANGE_REQUEST,
    Status.ERROR_GUARANTOR_CONTRACT_REVIEW,
    Status.GUARANTOR_CHANGE_REQUEST,
]

/**
 * Verifica si un estatus permite continuar en el punto Aserta
 * @param status Estatus de la emisión
 * @returns Verdadero si puede continuar, falso en caso contrario
 */
export const isContinueInPuntoAserta = (status: Status): boolean => {
    return continueInPuntoAsertaStatus.includes(status);
}

export const isSignatureStatus = (status: Status): boolean => {
    return (statusFAD.includes(status) || statusManualSigned.includes(status)) && status !== Status.CONTRACT_REVIEW;
}

export const isSignatureFadStatus = (status: Status): boolean => {
    return statusFAD.includes(status);
}